import React, { useEffect } from "react";
import { MdArrowBack } from "react-icons/md";
import Loader from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import CheckSuccess from "../../assets/images/check_success.svg";
import ErrorOrder from "../../assets/images/warning.svg";
import HelmetCustom from "../../components/HelmetCustom";
import { Creators as OrderActions } from "../../store/ducks/order";
import {
  Container, Content, ErrorMessage, KeepBuying,
  KeepBuyingLink,
  LoaderContainer, ContainerOrder,
  DivBadgeStyled
} from "./styles";
import storeIcon from "../../assets/images/storeIcon.svg";
import responsibleIcon from "../../assets/images/responsibleIcon.svg";
import timerIcon from "../../assets/images/timerIcon.svg";
import phoneIcon from "../../assets/images/phoneIcon.svg";
import cardIcon from "../../assets/images/cardIcon.svg";
import { FormaPagamento, TipoPagamento, obterDescricaoFormaPagamento } from "../../util/payment";
import BuyStepsTemplate from '../../components/BuyStepsTemplate';
import Breadcrumb from "../../components/Breadcrumb";
import { getReceiptTimeText } from '../../util/friendlyDate';
import { formatPrice } from "../../util/format";
import { DeliveryType } from '../../util/deliveryType';
import BadgePaymentProvider from "../../components/BadgePaymentProvider";

export default function OrderSuccess({ history }) {
  const { loading, error } = useSelector(state => state.cart);
  const { data } = useSelector(state => state.order);
  const storeData = useSelector(state => state.store.data);
  const dispatch = useDispatch();

  useEffect(() => {
    if (data === null) return history.push('/');
    return () => {
      dispatch(OrderActions.resetDeliveryMessage());
    };
  }, [data, dispatch, history]);

  if (loading) {
    return (
      <LoaderContainer>
        <Loader type="Oval" color="#007d44" height={40} width={40} />
      </LoaderContainer>
    );
  }

  if (error === null) {
    return (
      <BuyStepsTemplate step={4} history={history}>
        <HelmetCustom pageTitle="Pedido Realizado!" />
        <Breadcrumb items={[{ name: "Pedido finalizado" }]} jsonLd={false} />
        <Container>
          <Content>
            <img src={CheckSuccess} className="success-icon" alt="sucesso" />
            <div className='header'>
              <span className='title'>Compra finalizada</span>
            </div>
            <span className='successText'>Sua compra foi realizada e seu pedido está sendo preparado. Abaixo, estão os dados {data?.tipoEntrega === DeliveryType.RECEBER_EM_CASA || data?.tipoEntrega === DeliveryType.RECEBER_EM_CASA_EXPRESSA ? "da entrega" : "para retirada"}.</span>
            <ul>
              <li>
                <div className='card-icon-bg'>
                  <img src={storeIcon} title={"Opções de Entrega"}></img>
                </div>


                <div className="card-info">
                  <span className="card-description">
                    <strong>{data?.store?.nome_fantasia}</strong> | {data?.store?.endereco} {data?.store?.endereco_numero}, {data?.store?.cidade} - {data?.store?.uf} | CNPJ  {data?.store?.cnpj?.replace(
                      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
                      "$1.$2.$3/$4-$5"
                    )} | AFE - {data?.store?.caminho_afe}
                  </span>
                </div>
              </li>

              <li>
                <div className='card-icon-bg'>
                  <img src={responsibleIcon} title={"Responsible icon"}></img>
                </div>

                <div className="card-info">
                  <span className="card-title">Farmacêutico Responsável</span>
                  <span className="card-description">
                    {data?.store?.farmaceutico_nome} | Inscrição nº {data?.store?.farmaceutico_inscricao}
                  </span>
                </div>
              </li>

              {data?.store?.telefone && (
                <li>
                  <div className='card-icon-bg'>
                    <img src={phoneIcon} title={"Phone icon"}></img>
                  </div>

                  <div className="card-info">
                    <span className="card-title">Telefone para Contato</span>
                    <span className="card-description">
                      {data?.store?.telefone.replace(/(\d{2})(\d{4})(\d{4})/g, "($1) $2-$3")}
                    </span>
                  </div>
                </li>
              )}

              {data.orders.length > 0 && data.orders.map((order) => (
                <ContainerOrder key={order.id}>
                  <li>
                    <div className='card-info'>
                      <span className="subTitle">Nº do pedido: <strong>#{order.id}</strong></span>
                    </div>
                  </li>
                  <li>
                    <div className='card-icon-bg'>
                      <img src={timerIcon} title={"Timer icon"}></img>
                    </div>

                    <div className="card-info">
                      <span className="card-title">Tempo {data?.tipoEntrega === DeliveryType.RECEBER_EM_CASA || data?.tipoEntrega === DeliveryType.RECEBER_EM_CASA_EXPRESSA ? "de Entrega" : "para Retirada"}</span>
                      <span className="card-description">
                        Você {data?.tipoEntrega === DeliveryType.RECEBER_EM_CASA || data?.tipoEntrega === DeliveryType.RECEBER_EM_CASA_EXPRESSA ? "receberá" : "poderá retirar"} o seu pedido
                        {" "}
                        <b>{getReceiptTimeText(order.officeHour, data?.tipoEntrega)}</b>
                      </span>
                    </div>
                  </li>

                  {data?.payment?.formaPagamento && data?.payment?.tipoPagamento && (
                    <li>
                      <div className='card-icon-bg'>
                        <img src={cardIcon} title={"Card icon"}></img>
                      </div>

                      <div className="card-info">
                        <span className="card-title">Forma de pagamento</span>
                        <span className="card-description">
                          {obterDescricaoFormaPagamento(data?.payment?.formaPagamento)} {data?.payment?.formaPagamento === FormaPagamento.CartaoCredito ? `(${data?.payment?.tipoPagamento === TipoPagamento.Online ? 'online' : 'presencial'})` : null} - {formatPrice(order.totalAmountPayable)}
                        </span>
                      </div>
                    </li>
                  )}

                </ContainerOrder>
              ))}

            </ul>
            <div className="actions">
              <KeepBuying havebg={"true"} to="/painel/meus-pedidos">
                <span>Meus Pedidos</span>
              </KeepBuying>
              <KeepBuyingLink to="/">Continuar comprando</KeepBuyingLink>
            </div>
            <DivBadgeStyled>
              <BadgePaymentProvider
                provedor_pagamento_badge={
                  storeData?.empresa?.provedor_pagamento_badge
                }
                provedor_pgto_badge_ref={
                  storeData?.empresa?.provedor_pgto_badge_ref
                }
              />
            </DivBadgeStyled>
          </Content>
        </Container>
      </BuyStepsTemplate>
    );
  } else {
    return (
      <BuyStepsTemplate step={3} history={history}>
        <HelmetCustom pageTitle="Pedido Realizado!" />
        <Container>
          <ErrorMessage>
            <span className="titulo">Desculpe!</span>
            <img src={ErrorOrder} alt="Erro ao finalizar pedido" title="Erro ao finalizar Pedido" />
            <span className="descricao">
              Ocorreu um problema ao finalizar seu pedido
            </span>
            <span className="descricao-menor">
              Tente novamente, caso continue o problema, entre em contato conosco
            </span>

            <KeepBuying to="/carrinho">
              <MdArrowBack /> <span>Voltar para a cesta</span>
            </KeepBuying>
          </ErrorMessage>
        </Container>
      </BuyStepsTemplate>

    );
  }
}
